import { combineEpics } from 'redux-observable';
import analytics from './analytics/analytics-epic.tsx';

export default combineEpics(analytics);
